import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => setShowBanner(true), 1000);
    } else if (consent === 'accepted') {
      // User previously accepted, enable GA
      enableGoogleAnalytics();
    }
  }, []);

  const enableGoogleAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted'
      });
    }
  };

  const disableGoogleAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied'
      });
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    enableGoogleAnalytics();
    closeBanner();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    disableGoogleAnalytics();
    closeBanner();
  };

  const closeBanner = () => {
    setFadeOut(true);
    setTimeout(() => setShowBanner(false), 300);
  };

  if (!showBanner) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-gray-900/95 backdrop-blur-md border-t border-amber-500/20 shadow-2xl transition-all duration-300 ${
        fadeOut ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {/* Message */}
          <div className="flex-1">
            <p className="text-sm text-gray-300 leading-relaxed">
              We use cookies and Google Analytics to improve your experience and analyze site traffic.
              By clicking <span className="font-semibold text-amber-400">"Accept"</span>, you consent to our use of cookies.{' '}
              <a
                href="/privacy"
                className="text-amber-400 hover:text-amber-300 underline transition-colors"
              >
                Learn more
              </a>
            </p>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white bg-gray-800 hover:bg-gray-700 rounded-lg transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-500"
              aria-label="Decline cookies"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 text-sm font-medium text-black bg-amber-400 hover:bg-amber-300 rounded-lg transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-amber-500 shadow-lg"
              aria-label="Accept cookies"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
